import { useEffect, useState } from "react";
import { siteMeta } from "@/mocks/siteMeta";

const navItems = [
  { label: "最新地址", href: "#addresses" },
  { label: "APP入口", href: "#app" },
  { label: "防走失", href: "#guide" },
  { label: "方式对比", href: "#compare" },
  { label: "更新记录", href: "#log" },
  { label: "常见问题", href: "#faq" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="bg-primary-600 text-background-50">
        <div className="w-full px-4 md:px-6 h-9 flex items-center gap-3 text-xs md:text-[13px]">
          <span className="relative flex w-2 h-2 shrink-0 items-center justify-center">
            <span className="absolute inline-flex h-2 w-2 rounded-full bg-accent-400 animate-ping"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
          </span>
          <span className="whitespace-nowrap font-medium">最近更新 {siteMeta.updatedAt}</span>
          <span className="hidden sm:inline text-primary-200">|</span>
          <span className="hidden sm:inline whitespace-nowrap text-background-100">{siteMeta.statusText}</span>
          <span className="ml-auto hidden md:flex items-center gap-1.5 whitespace-nowrap text-background-100">
            <i className="ri-information-line"></i>
            本页为地址汇总页，地址变化以本页为准
          </span>
        </div>
      </div>

      <div className={`w-full transition-colors duration-300 ${solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"}`}>
        <div className="w-full px-4 md:px-6 h-16 flex items-center justify-between gap-4">
          <a href="#top" className={`flex items-center gap-2.5 shrink-0 cursor-pointer ${solid ? "text-foreground-950" : "text-background-50"}`}>
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-play-circle-fill text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg tracking-wide">{siteMeta.siteName}</span>
              <span className={`text-[10px] mt-1 ${solid ? "text-foreground-500" : "text-background-200"}`}>网址发布页</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  solid
                    ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                    : "text-background-100 hover:bg-white/10 hover:text-white"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#addresses"
              className="hidden sm:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-links-line"></i>取最新地址
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              className={`lg:hidden w-9 h-9 rounded-md flex items-center justify-center cursor-pointer transition-colors ${
                solid ? "text-foreground-950 bg-background-100" : "text-background-50 bg-white/10"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <nav className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="block px-2 py-3 rounded-md text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        ) : null}
      </div>
    </header>
  );
}